import { Select } from "react-functional-select";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { ReactComponent as Arrow } from "../../../../../assets/icons/pesquisa/select-seta.svg";
import { ReactComponent as Clear } from "../../../../../assets/icons/pesquisa/fechar-select.svg";
import { ButtonMuiltiSelect } from "../../../../helpers/tratarInfo";
import css from "../pesquisa.module.css";

export default function Modelos({
  Array,
  onChange,
  UpdateSelectRef,
  infoJson,
}) {
  const selectRef = useRef();
  const [option, setOption] = useState([]);

  const getOptionValue = useCallback((option) => option.Modelo.Id, []);
  const getOptionLabel = useCallback((option) => option.Modelo.Nome, []);

  const onOptionChange = (option) => {
    const item = option.map((i) => {
      return i.Modelo.Id;
    });
    const selectedInt = item.map((i) => Number(i));
    onChange(selectedInt);
  };

  const renderMultiOptions = useCallback(
    ({ selected }) => (
      <div>
        {selected.length > 0 &&
          `${selected.length} ${
            selected.length === 1 ? "selecionado" : "selecionados"
          }`}
      </div>
    ),
    []
  );

  useEffect(() => {
    const item = Array.sort(function (a, b) {
      if (a.Modelo.Nome < b.Modelo.Nome) {
        return -1;
      }
      if (a.Modelo.Nome > b.Modelo.Nome) {
        return 1;
      }
      return 0;
    }).reduce((accum, carro) => {
      const accumulator = [...accum];
      if (!accumulator.some((item) => item.Modelo.Id === carro.Modelo.Id)) {
        accumulator.push(carro);
      }
      return accumulator;
    }, []);
    setOption(item);
    UpdateSelectRef && UpdateSelectRef(selectRef);
  }, [Array, UpdateSelectRef]);

  const clear = (
    <span>
      <Clear fill={infoJson.Cores.SVG} width="10px" />
    </span>
  );
  const arrow = (
    <span>
      <Arrow fill={infoJson.Cores.SVG} className={css.arrow} />
    </span>
  );
  return (
    <Select
      isMulti
      isClearable
      isSearchable={false}
      options={option}
      placeholder="Selecionar"
      onOptionChange={onOptionChange}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      openMenuOnClick={true}
      blurInputOnSelect={false}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      renderMultiOptions={renderMultiOptions}
      noOptionsMsg="Não existe"
      clearIcon={clear}
      caretIcon={arrow}
      themeConfig={ButtonMuiltiSelect(infoJson)}
    />
  );
}
